module.exports = __webpack_public_path__ + "img/1595.c4d7366a.png";